import radium from 'radium';

import Button from '../../components/button/Button.tsx';
import {navigateToEntranceIfGiven} from "../../lib/nav-util-service.js";

function EventPageSeatingplanBtnFn(props) {
    function openEventPageSeatingplan() {
        const eventPageUrl = `sp/${props.eventUUID}`;
        navigateToEntranceIfGiven(eventPageUrl)
    }

    const style = {
        width: '100%',
        height: '100%',
    };

    return (
        <Button
            buttonContainerStyle={style}
            name="eventPageSeatingplan"
            buttonText="Zurück"
            onClick={openEventPageSeatingplan}
        />
    );
}

const EventPageSeatingplanBtn = radium(EventPageSeatingplanBtnFn);
export default EventPageSeatingplanBtn;
